import React from 'react';

import {
  LegacyBox,
  ConfirmDialog,
  Stack,
  Typography,
} from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ItemsList from 'scenes/Annotations/components/ItemsList';
import { deleteAnnotation } from 'scenes/Annotations/sources/annotations';

import {
  COLUMN_AFFILIATES,
  COLUMN_APPLICATIONS,
  COLUMN_CLUSTERS,
  COLUMN_NETWORKS,
  COLUMN_PLATFORMS,
} from '../../constants';
import { remove } from '../queryKeyFactory';

const descriptionsItems = [
  COLUMN_AFFILIATES,
  COLUMN_APPLICATIONS,
  COLUMN_NETWORKS,
  COLUMN_CLUSTERS,
  COLUMN_PLATFORMS,
];

export const useDeleteAnnotation = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const deleteMutation = useMutation(remove(), deleteAnnotation, {
    successMessage: () => `Annotation deleted`,
  });
  const handleDelete = async ({ period, user, description, id, ...params }) => {
    await showModal({
      title: `Delete Annotation?`,
      confirmActionLabel: 'Delete',
      children: (
        <Stack direction={'column'}>
          <LegacyBox
            wrap={'wrap'}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              margin: '5px -8px',
            }}
          >
            <ItemsList data={params} fieldsForRender={descriptionsItems} />
          </LegacyBox>
          <LegacyBox
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Typography>
              {period ? (
                <DateRangeFormatter
                  value={period}
                  template={'LL'}
                  timeZone={'local'}
                />
              ) : null}{' '}
              {user && user.name ? `by ${user.name}` : 'by Game Server'}
            </Typography>
          </LegacyBox>
        </Stack>
      ),
    });

    await deleteMutation.mutateAsync({ id });
  };

  return [handleDelete, deleteMutation];
};
